/**
 * Shim de compatibilidade: next/head
 *
 * Usado em 2 arquivos. Aplica title/meta diretamente no document, o que cobre o
 * uso real do projeto (o componente Page define o titulo da aba).
 *
 * Alias em vite.config.ts (resolve.alias['next/head']).
 */
import * as React from 'react';

function extrairTitulo(children: React.ReactNode): string | null {
  let titulo: string | null = null;
  React.Children.forEach(children, (filho: any) => {
    if (!filho) return;
    if (filho.type === 'title') {
      const conteudo = filho.props?.children;
      titulo = Array.isArray(conteudo) ? conteudo.join('') : String(conteudo ?? '');
    }
    if (filho.props?.children && filho.type !== 'title') {
      const aninhado = extrairTitulo(filho.props.children);
      if (aninhado) titulo = aninhado;
    }
  });
  return titulo;
}

export default function Head({ children }: { children?: React.ReactNode }) {
  React.useEffect(() => {
    const titulo = extrairTitulo(children);
    if (titulo) document.title = titulo;
  }, [children]);

  return null;
}
